import { Box } from '@mui/material'
import {
  useScheduleProductionRequirements,
  useSchedulerTableHandlers,
} from './Scheduler.data'
import { SchedulerSteriliserTypesTable } from './SchedulerSteriliserTypes.muiTable'
import { ManagedSourceBanner } from './ManagedSourceBanner'
import { SECTIONS } from './SchedulerInput.sections'

interface ScheduleSORlikeViewProps {
  schedulerId: string
  iteration: string
  API: string
  readOnly?: boolean
  onOpenRule?: (tab: string) => void
}

export const ScheduleSORlikeView = ({
  schedulerId,
  iteration,
  API,
  readOnly = false,
  onOpenRule,
}: ScheduleSORlikeViewProps) => {
  const { data: responseData = { data: [], predicate: undefined }, isLoading } =
    useScheduleProductionRequirements(schedulerId, API, iteration)
  const { data = [], predicate } = responseData

  const {
    updateTableData,
    uploadScheduleData,
    deleteTableData,
    isSaving,
    isUploading,
    isDeleting,
    updateRowsStatus,
  } = useSchedulerTableHandlers(schedulerId, API, iteration)

  return (
    <Box sx={{ height: 'calc(100vh - 240px)', minHeight: 400 }}>
      {readOnly && onOpenRule && (
        <ManagedSourceBanner
          label="Steriliser"
          onOpen={() => onOpenRule(SECTIONS.RULES_STERILISER)}
        />
      )}
      <SchedulerSteriliserTypesTable
        data={data}
        isLoading={isLoading}
        updateTableData={updateTableData}
        uploadScheduleData={uploadScheduleData}
        isUploading={isUploading}
        isSaving={isSaving}
        updateRowsStatus={updateRowsStatus}
        predicate={predicate}
        deleteTableData={deleteTableData}
        isDeleting={isDeleting}
        readOnly={readOnly}
      />
    </Box>
  )
}
